/**
 * defa.collections.Calendars
 * A Collection of Calendars
 * @version 1.0.0
 */
import Calendar from './model-calendar';

const Calendars = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : Calendar,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default Calendars;